import React, { createContext, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { useForm } from 'antd/es/form/Form';
// COMENTARIO
export const EnrollmentFormContext = createContext({
  enrollmentForm: {},
});

const EnrollmentFormContextProvider = ({ children }) => {
  const [enrollmentForm] = useForm();

  const contextValue = useMemo(
    () => ({
      enrollmentForm,
    }),
    [enrollmentForm]
  );

  return (
    <EnrollmentFormContext.Provider value={contextValue}>{children}</EnrollmentFormContext.Provider>
  );
};

EnrollmentFormContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default EnrollmentFormContextProvider;
